import SolarGenerationVsIrradiance from "./SolarGenerationVsIrradiance";

const MONTH_SLUGS = [
  "january",
  "february",
  "march",
  "april",
  "may",
  "june",
  "july",
  "august",
  "september",
  "october",
  "november",
  "december",
];

function toMonthStartDate(value) {
  if (!(value instanceof Date) || Number.isNaN(value.getTime())) return null;
  return new Date(value.getFullYear(), value.getMonth(), 1);
}

/** YYYY-MM-01 for Snowflake PERIOD_MONTH filters. */
export function toIsoMonthStart(value) {
  const month = toMonthStartDate(value);
  if (!month) return null;
  const y = month.getFullYear();
  const m = String(month.getMonth() + 1).padStart(2, "0");
  return `${y}-${m}-01`;
}

/** Insights duration slug, e.g. july-2025. */
export function toInsightsMonthSlug(value) {
  const month = toMonthStartDate(value);
  if (!month) return null;
  return `${MONTH_SLUGS[month.getMonth()]}-${month.getFullYear()}`;
}

const PVUSA_MIN_IRRADIANCE_WPM2 = 400;
const PVUSA_MIN_MW_PER_IRRADIANCE = 0.7;

/**
 * Plant-level solar output vs irradiance scatter for the PV USA Model page.
 * Loads real points from ML_SOLAR_GENERATION_VS_IRRADIANCE via the insights API,
 * sampling across the selected month range.
 * Filters: irradiance >= 400 W/m² and (MWdc / irradiance) >= 0.7.
 */
export default function PlantSolarOutputVsIrradiance({
  portfolioName,
  range,
  onTooltip,
}) {
  const startMonth = toIsoMonthStart(range?.start);
  const endMonth = toIsoMonthStart(range?.end) || startMonth;
  const duration = toInsightsMonthSlug(range?.end) || toInsightsMonthSlug(range?.start) || "june-2026";

  return (
    <SolarGenerationVsIrradiance
      portfolioName={portfolioName}
      duration={duration}
      startMonth={startMonth}
      endMonth={endMonth}
      minIrradiance={PVUSA_MIN_IRRADIANCE_WPM2}
      minMwPerIrradiance={PVUSA_MIN_MW_PER_IRRADIANCE}
      xDomainMin={200}
      xDomainMax={1000}
      yDomainMin={300}
      yDomainMax={1200}
      onTooltip={onTooltip}
      xAxisLabel="Plant Solar Output (MW DC)"
      yAxisLabel="Irradiance (W/m2)"
      ariaLabel="Plant solar output vs irradiance scatter plot. Tab or click to select a data point; use arrow keys to move the selection; use + and - to zoom in and out around the selected point."
    />
  );
}
